import { render, staticRenderFns } from "./TrasladosEstudiantesGrupo.vue?vue&type=template&id=85a6b2a8&"
import script from "./TrasladosEstudiantesGrupo.vue?vue&type=script&lang=js&"
export * from "./TrasladosEstudiantesGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports